import { configureStore } from "@reduxjs/toolkit";
import uireducer from "./Slices/uiSlice";
import profileReducer from "./Slices/profileSlice";
import profileReducerOrg from "./Slices/OrgProfileSlice";
import kyc from "./Slices/kycSlice";
import customerReducer from "./Slices/customerSlice";
import customerReducerOrg from "./Slices/orgCustomerSlice";
import kycOrg from "./Slices/OrgkycSlice";
import profileDetailsReducer from "./Slices/associateProfileDetailsSlice";
const store = configureStore({
  reducer: {
    uiReducers: uireducer,
    profile: profileReducer,
    OrgProfile: profileReducerOrg,
    kyc: kyc,
    kycOrg: kycOrg,
    customerReducer: customerReducer,
    orgCustomerReducer: customerReducerOrg,
    assoProfileDetails: profileDetailsReducer,
  },
});
export default store;
